import { View, Dimensions } from "react-native";
import ContentLoader from "../../components/General/ContentLoader";


const eventInfo  = () => (<View style={{padding:10}}>
    <ContentLoader containerHeight={40} containerWidth={"50%"} style={{alignSelf:"center"}} />

    <View style={{paddingVertical:10}}>
        <ContentLoader containerHeight={25} containerWidth={"60%"} staggerPosition={1} />
        <ContentLoader containerHeight={25} spacingVertical={0} staggerPosition={1}/>
    </View>
    <View style={{paddingVertical:10}}>
        <ContentLoader containerHeight={25} containerWidth={"40%"} staggerPosition={2}/>
        <ContentLoader containerHeight={25} spacingVertical={0} staggerPosition={2}/>
    </View>

    <ContentLoader containerHeight={40} containerWidth={"50%"} staggerPosition={3} style={{alignSelf:"center", marginTop:40}} />

    <View style={{paddingVertical:10}}>
        <ContentLoader containerHeight={25} containerWidth={"40%"} staggerPosition={4} />
        <ContentLoader containerHeight={25} containerWidth={"80%"} staggerPosition={4} spacingVertical={0}/>
        <ContentLoader containerHeight={25} containerWidth={"60%"} staggerPosition={4}/>
        <ContentLoader containerHeight={25} spacingVertical={0} staggerPosition={4}/>
    </View>


    <ContentLoader containerHeight={40} containerWidth={"50%"} staggerPosition={5} style={{alignSelf:"center", marginTop:40}} />

    <View style={{paddingVertical:10}}>
        <ContentLoader staggerPosition={5} />
    </View>
</View>)


const list = ({amount = 5, height = 70, fillScreen = false} = {}) => {
    let numberOfItems = amount;
    if (fillScreen) {
        const windowHeight = Dimensions.get('window').height;
        numberOfItems = Math.ceil(windowHeight / (height + 10));
    }
    
    return (<View style={{}}>
        {[...Array(numberOfItems).keys()].map((key) => <ContentLoader key={key} containerHeight={height} staggerPosition={key} />)}
    </View>)
}


const drawerMenu = () => (<View style={{padding:10}}>
    <ContentLoader invert containerHeight={65} style={{alignSelf:"center", marginVertical:10}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginVertical:20}} />
    <ContentLoader invert containerHeight={20} containerWidth="50%" style={{marginTop:20}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={20} containerWidth="50%" style={{marginTop:30}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={20} containerWidth="50%" style={{marginTop:30}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
    <ContentLoader invert containerHeight={40} style={{alignSelf:"center", marginTop:10}} />
</View>)


const dashboard = () => (<View style={{padding:10}}>
    <ContentLoader staggerPosition={0} containerHeight={40} style={{alignSelf:"center", marginVertical:10}} />
    <View style={{flexDirection:"row", gap:10, alignItems:"center"}}>
        <ContentLoader staggerPosition={1} containerHeight={100} containerWidth={100} style={{marginBottom:10}} />
        <ContentLoader staggerPosition={1} containerHeight={100} containerWidth={100} style={{marginBottom:10}} />
        <ContentLoader staggerPosition={1} containerHeight={100} containerWidth={100} style={{marginBottom:10}} />
        <ContentLoader staggerPosition={1} containerHeight={100} containerWidth={100} style={{marginBottom:10}} />
    </View>
    <View style={{ gap:10, alignItems:"center"}}>
        <ContentLoader staggerPosition={2} containerHeight={300} containerWidth="100%" style={{marginBottom:10}} />  
        <ContentLoader staggerPosition={2} containerHeight={300} containerWidth="100%" style={{marginBottom:10}} />  
    </View>
</View>)


const tabs = () => (<View style={{padding:10, flexDirection:"row", alignItems:"center", justifyContent:"space-between"}}>
    <ContentLoader containerHeight={20} containerWidth={"22%"} />
    <ContentLoader containerHeight={20} containerWidth={"22%"}/>
    <ContentLoader containerHeight={20} containerWidth={"22%"}/>
    <ContentLoader containerHeight={20} containerWidth={"22%"}/>
</View>)


const profile = () => (
    <View style={{ width: "100%"}}>
        {/* Header Card */}
        <View style={{backgroundColor: 'transparent', borderRadius: 12, marginBottom: 16}}>
            {/* Avatar Row */}
            <View style={{flexDirection: 'row', alignItems: 'flex-start', marginBottom: 16}}>
                <ContentLoader containerHeight={80} containerWidth={80} borderRadius={40} spacingVertical={0} />
                <View style={{flex: 1, marginLeft: 16}}>
                    <ContentLoader containerHeight={24} containerWidth="70%" staggerPosition={1} spacingVertical={4} />
                    <ContentLoader containerHeight={16} containerWidth="40%" staggerPosition={1} spacingVertical={4} />
                </View>
            </View>

            {/* Stats Row */}
            <View style={{flexDirection: 'row', alignItems: 'center', paddingVertical: 14, marginBottom: 14}}>
                <View style={{flex: 1, alignItems: 'center'}}>
                    <ContentLoader containerHeight={12} containerWidth="60%" staggerPosition={2} spacingVertical={2} />
                    <ContentLoader containerHeight={14} containerWidth="40%" staggerPosition={2} spacingVertical={2} />
                </View>
                <View style={{flex: 1, alignItems: 'center'}}>
                    <ContentLoader containerHeight={12} containerWidth="60%" staggerPosition={2} spacingVertical={2} />
                    <ContentLoader containerHeight={14} containerWidth="40%" staggerPosition={2} spacingVertical={2} />
                </View>
            </View>

            {/* Family Avatars Row */}
            <View style={{flexDirection: 'row', gap: 6, marginBottom: 14}}>
                <ContentLoader containerHeight={32} containerWidth={32} borderRadius={16} staggerPosition={3} spacingVertical={0} />
                <ContentLoader containerHeight={32} containerWidth={32} borderRadius={16} staggerPosition={3} spacingVertical={0} />
                <ContentLoader containerHeight={32} containerWidth={32} borderRadius={16} staggerPosition={3} spacingVertical={0} />
            </View>

            {/* Action Buttons */}
            <View style={{flexDirection: 'row', gap: 8}}>
                <ContentLoader containerHeight={40} containerWidth="30%" borderRadius={8} staggerPosition={4} spacingVertical={0} />
                <ContentLoader containerHeight={40} containerWidth="30%" borderRadius={8} staggerPosition={4} spacingVertical={0} />
                <ContentLoader containerHeight={40} containerWidth="30%" borderRadius={8} staggerPosition={4} spacingVertical={0} />
            </View>
        </View>

        {/* Info Section */}
        <View style={{borderRadius: 12,}}>
            <ContentLoader containerHeight={50} staggerPosition={5} spacingVertical={6} borderRadius={8} />
            <ContentLoader containerHeight={50} staggerPosition={5} spacingVertical={6} borderRadius={8} />
            <ContentLoader containerHeight={50} staggerPosition={5} spacingVertical={6} borderRadius={8} />
            <ContentLoader containerHeight={50} staggerPosition={5} spacingVertical={6} borderRadius={8} />
            <ContentLoader containerHeight={50} staggerPosition={5} spacingVertical={6} borderRadius={8} />
        </View>
    </View>
)

const profileEdit = () => (<View style={{padding:10}}>
        <View style={{paddingVertical:10, flexDirection:"row", alignItems:"center", justifyContent:"space-between"}}>
            <View style={{width:"60%"}}>
                <ContentLoader containerHeight={20} containerWidth={"60%"} staggerPosition={1} />
                <ContentLoader containerHeight={20} containerWidth={"100%"}staggerPosition={1}/>
            </View>

            <ContentLoader containerHeight={50} containerWidth={50} borderRadius={50} staggerPosition={1}/>
        </View>

        <View style={{paddingVertical:10, flexDirection:"row", gap:10, alignItems:"center"}}>
            <ContentLoader containerHeight={50} containerWidth={"48%"} staggerPosition={2} />
            <ContentLoader containerHeight={50} containerWidth={"48%"} staggerPosition={2}/>
        </View>

        <View style={{paddingVertical:10}}>
            <ContentLoader containerHeight={50}  staggerPosition={3}/>
            <ContentLoader containerHeight={50} staggerPosition={3}/>
        </View>
    </View>
)

const messages = () => {
    return <View style={{marginHorizontal:20, justifyContent:"center", alignItems:"center", height:"100%"}}>
        <View style={{alignSelf:"flex-start", width:"60%"}}><ContentLoader containerHeight={40} staggerPosition={1}/></View>
        <View style={{alignSelf:"flex-start", width:"40%"}}><ContentLoader containerHeight={60} staggerPosition={2}/></View>
        <View style={{alignSelf:"flex-end", width:"60%"}}><ContentLoader containerHeight={40} staggerPosition={3}/></View>
        <View style={{alignSelf:"flex-start", width:"60%"}}><ContentLoader containerHeight={40} staggerPosition={4}/></View>
        <View style={{alignSelf:"flex-end", width:"50%"}}><ContentLoader containerHeight={80} staggerPosition={5}/></View>
        <View style={{alignSelf:"flex-start", width:"60%"}}><ContentLoader containerHeight={40} staggerPosition={6}/></View>
        <View style={{alignSelf:"flex-end", width:"40%"}}><ContentLoader containerHeight={60} staggerPosition={7}/></View>
        <View style={{alignSelf:"flex-end", width:"80%"}}><ContentLoader containerHeight={40} staggerPosition={8}/></View>
        <View style={{alignSelf:"flex-start", width:"40%"}}><ContentLoader containerHeight={40} staggerPosition={9}/></View>
        <View style={{alignSelf:"flex-end", width:"40%"}}><ContentLoader containerHeight={40} staggerPosition={10}/></View>
    </View>
}

export {
    eventInfo,
    list,
    tabs,
    profile,
    profileEdit,
    messages,
    drawerMenu,
    dashboard
}